import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { LernsetProvider } from './flashcard/LearnsetContext';
import Navbar from './home/Navbar';
import Footer from './home/Footer';
import Home from './home/Home';
import Login from './auth/Login';
import Register from './auth/Register';
import ForgotPassword from './auth/ForgotPassword';
import VerifyEmail from './auth/VerifyEmail';
import EmailBestaetigtPage from './auth/ConfirmEmail';
import AI_Generator from './flashcard/generator/AI_Generator';
import AI_GeneratorForLernset from './flashcard/generator/AI_GeneratorForLernset';
import Learnsets from './flashcard/Learnsets';
import LernsetDashboard from './flashcard/LearnsetDashboard';
import CreateFlashcards from './flashcard/CreateFlashcards';
import LearnMode from './flashcard/LearnMode';
import CardList from './flashcard/CardList';
import ProtectedRoute from './auth/ProtectedRoute';
import Impressum from './legislation/Impressum';
import Datenschutz from './legislation/Datenschutz';
import AGB from './legislation/AGB';
import Widerruf from './legislation/Widerruf';
import { UserbackSync } from './userback/UserbackSync';
import Upgrade from './abo/Upgrade';
import Profile from './auth/Profile';
import CookieBanner from './legislation/CookieBanner';

function App() {
    return (
        <Router>
            <AuthProvider>
                <LernsetProvider>
                    <UserbackSync />
                    <div className="flex flex-col min-h-screen">
                        <Navbar />
                        <main className="flex-grow pt-16">
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/register" element={<Register />} />
                                <Route path="/passwort-vergessen" element={<ForgotPassword />} />
                                <Route path="/verify-email" element={<VerifyEmail />} />
                                <Route path="/email-bestaetigt" element={<EmailBestaetigtPage />} />
                                <Route path="/erstellen" element={<ProtectedRoute><AI_Generator /></ProtectedRoute>} />
                                <Route path="/lernsets" element={<ProtectedRoute><Learnsets /></ProtectedRoute>} />
                                <Route path="/lernset/:id" element={<ProtectedRoute><LernsetDashboard /></ProtectedRoute>} />
                                <Route path="/lernset/:id/create" element={<ProtectedRoute><CreateFlashcards /></ProtectedRoute>} />
                                <Route path="/lernset/:id/learn/crash" element={<ProtectedRoute><LearnMode /></ProtectedRoute>} />
                                <Route path="/lernset/:id/learn/daily" element={<ProtectedRoute><LearnMode /></ProtectedRoute>} />
                                <Route path="/lernset/:id/generate" element={<ProtectedRoute><AI_GeneratorForLernset /></ProtectedRoute>} />
                                <Route path="/lernset/:id/cards" element={<ProtectedRoute><CardList /></ProtectedRoute>} />
                                <Route path="/upgrade" element={<ProtectedRoute><Upgrade /></ProtectedRoute>} />
                                <Route path="/profil" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                                <Route path="/impressum" element={<Impressum />} />
                                <Route path="/datenschutz" element={<Datenschutz />} />
                                <Route path="/agb" element={<AGB />} />
                                <Route path="/widerruf" element={<Widerruf />} />
                            </Routes>
                        </main>
                        <Footer />
                        <CookieBanner />
                    </div>
                </LernsetProvider>
            </AuthProvider>
        </Router>
    );
}

export default App;